import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-page',
  templateUrl: './not-page.component.html',
  styleUrls: ['./not-page.component.css']
})
export class NotPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
